export default __webpack_public_path__ + "static/Calien_Soup-51c8c8cd2533e1bbdae1807d71db0109.png";